<script lang="ts">
	import { page } from '$app/stores';
	import SeoTags from '$lib/components/SeoTags.svelte';
	import TrailCard from '$lib/components/TrailCard.svelte';
	import { Tag as TagIcon, ArrowLeft } from 'lucide-svelte';

	export let data;
	const { tag, trails, similarTags } = data;

	// Decode the tag for display
	const decodedTag = decodeURIComponent(tag);
</script>

<SeoTags
	data={{
		title: `${decodedTag} Trails | Herd Trail Hub`,
		description: `Explore automation trails tagged with ${decodedTag} in the Herd Trail Hub`
	}}
/>

<div class="container mx-auto px-4 py-8 max-w-6xl">
	<div class="mb-8">
		<a href="/trails/tags" class="inline-flex items-center text-primary hover:underline mb-4">
			<ArrowLeft class="mr-1" size={16} />
			<span>Back to all tags</span>
		</a>

		<div class="flex items-center gap-4 mb-2">
			<div class="w-12 h-12 rounded-full bg-surface-2 flex items-center justify-center">
				<TagIcon size={24} class="text-primary" />
			</div>
			<h1 class="text-3xl font-bold text-white">
				Trails Tagged with "{decodedTag}"
			</h1>
		</div>
		<p class="text-gray-400">
			Discover automation trails related to {decodedTag}
		</p>
	</div>

	{#if trails.length > 0}
		<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
			{#each trails as trail}
				<TrailCard {trail} />
			{/each}
		</div>
	{:else}
		<div class="bg-surface-2 rounded-xl p-6">
			<div class="text-center mb-8">
				<p class="text-xl text-gray-400 mb-2">No trails found with this tag yet</p>
				<p class="text-gray-500">Be the first to create a trail with the "{decodedTag}" tag!</p>
			</div>

			{#if similarTags.length > 0}
				<div class="border-t border-surface-3 pt-6">
					<h2 class="text-lg font-semibold text-white mb-4">
						You might be interested in these similar tags:
					</h2>
					<div class="flex flex-wrap gap-2">
						{#each similarTags as similarTag}
							<a
								href="/trails/tags/{encodeURIComponent(similarTag.name)}"
								class="px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5 border border-surface-3 text-gray-300 hover:border-primary hover:text-white transition-colors"
							>
								<span>{similarTag.name}</span>
								{#if similarTag.count !== undefined}
									<span class="bg-surface-3 text-xs rounded-full px-1.5 py-0.5">
										{similarTag.count}
									</span>
								{/if}
							</a>
						{/each}
					</div>
				</div>
			{/if}

			<div class="text-center mt-6">
				<a href="/trails/tags" class="inline-block text-primary hover:underline">
					Browse all tags
				</a>
			</div>
		</div>
	{/if}
</div>
